/**
 * Product card quick add via REST cart API.
 */

import { apiFetch, openCartDrawer, announceCart } from './cart-drawer.js';
import { showToast } from './toast.js';

function getConfig() {
	return window.doneCommerce || {};
}

export function initProductCardQuickAdd() {
	document.addEventListener('click', async (e) => {
		const btn = e.target.closest('[data-quick-add]');
		if (!btn || btn.disabled) {
			return;
		}

		e.preventDefault();

		const productId = Number(btn.dataset.productId);
		if (!productId) {
			return;
		}

		btn.disabled = true;
		btn.classList.add('is-loading');
		const label = btn.querySelector('[data-quick-add-label]');
		const originalText = label?.textContent || btn.textContent;

		if (label) {
			label.textContent = getConfig().i18n?.addingToCart || 'Adding…';
		}

		try {
			await apiFetch('done-commerce/v1/cart/items', {
				method: 'POST',
				body: JSON.stringify({ product_id: productId, quantity: 1 }),
			});

			const message = getConfig().i18n?.addedToCart || 'Added to cart';
			showToast(message);
			openCartDrawer({ announce: message });
		} catch {
			const fail = getConfig().i18n?.addToCartFailed || 'Unable to add to cart';
			showToast(fail, { variant: 'error' });
			announceCart(fail);
		} finally {
			btn.disabled = false;
			btn.classList.remove('is-loading');
			if (label) {
				label.textContent = originalText;
			}
		}
	});
}
